/**
 * The string to search for within the object
 */
export type Query = string;
export interface SearchOptions {
  /**
   * A function called for each key value pair.
   * If returns true will not allow that to appear in the result set
   */
  excludeFromSearch?: (key: string, value: unknown) => boolean;
}
/**
 * Searches an object for a query string
 * @param query The query string to search for
 */
export default function searchObjectFactory(
  query: string,
  { excludeFromSearch = () => false }: SearchOptions = {}
) {
  /**
   * Search an object with previously specified query string
   */
  return function searchObject<T extends Record<string, unknown>>(item: T): boolean {
    if (!query) {
      return true;
    }

    const search = query.split(' ').map(s => s.toLowerCase());

    return Object.entries(item).some(([key, value]) => {
      if (excludeFromSearch(key, value)) {
        return false;
      }

      if (typeof value === 'string') {
        return search.every(s => value.toLowerCase().includes(s));
      }

      if ((Array.isArray(value) || typeof value === 'object') && value !== null) {
        return searchObject(value as T);
      }

      return false;
    });
  };
}
